import chefSignature from "../../../assets/Signature.png";
import LucaFatin from "../../../assets/Luca_Fatin_about.jpg"

const BioSection = ({t}) => {
    return (
        <section className="bg-[#FFF]">
            <div className="container mx-auto px-4 max-w-[1200px]">
                <div className="flex flex-wrap -mx-4">
                    {/* Left Column */}
                    <div className="w-full lg:w-1/2 px-4 mb-12 lg:mb-0">
                        <h5 className="text-[#C7702A] uppercase mb-2 font-['Jost',sans-serif] text-[15px] font-normal">{t?.meetChef}</h5>
                        <h2 className="text-[#1F0707] font-['__Libre_Caslon_Display_20614e'] text-[40px] font-medium tracking-[-0.6px] leading-[48px] mb-6">{t?.chefTitle}</h2>
                        <p className="mb-6 text-[rgba(31,7,7,0.62)] text-[18px] font-['__Jost_461405'] font-normal leading-[28.8px] text-size-adjust-100 unicode-bidi-isolate transition-[background_.3s,border_.3s,border-radius_.3s,box-shadow_.3s] transform duration-[var(--e-transform-transition-duration,0.4s)]">{t?.chefDescription1}</p>
                        <p className="mb-6 text-[rgba(31,7,7,0.62)] text-[18px] font-['__Jost_461405'] font-normal leading-[28.8px] text-size-adjust-100 unicode-bidi-isolate transition-[background_.3s,border_.3s,border-radius_.3s,box-shadow_.3s] transform duration-[var(--e-transform-transition-duration,0.4s)]">{t?.chefDescription2}</p>
                        <p className="mb-6 text-[rgba(31,7,7,0.62)] text-[18px] font-['__Jost_461405'] font-normal leading-[28.8px] text-size-adjust-100 unicode-bidi-isolate transition-[background_.3s,border_.3s,border-radius_.3s,box-shadow_.3s] transform duration-[var(--e-transform-transition-duration,0.4s)]">{t?.chefDescription3}</p>
                        <img 
                            src={chefSignature}
                            alt="Signature"
                            width={307}
                            height={100}
                            className="ml-auto -rotate-18 transform"
                        />
                    </div>
                    {/* Right Column */}
                    <div className="w-full lg:w-1/2 px-4">
                        <img 
                            src={LucaFatin}
                            alt="Chef Luca Fantin"
                            width={600}
                            height={650}
                            className="w-full h-auto object-cover rounded-xl"
                        />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default BioSection;